import { useEffect, useState } from "react";
import evidenceProjects, { featuredProjects } from "../data/projects";
import { fetchProjects } from "../utils/evidenciasApi";

/**
 * Proyectos de evidencias: primero los subidos desde el panel (API), luego los
 * fijos de src/data/projects.js. Si la API falla, se muestran solo los fijos.
 * `featured` son los más recientes del panel completados con los destacados fijos.
 */
const useEvidenceProjects = (featuredCount = 3) => {
  const [uploaded, setUploaded] = useState([]);

  useEffect(() => {
    let active = true;
    fetchProjects()
      .then((projects) => active && setUploaded(projects))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return {
    projects: [...uploaded, ...evidenceProjects],
    featured: [...uploaded, ...featuredProjects].slice(0, featuredCount),
  };
};

export default useEvidenceProjects;
